// extracted by mini-css-extract-plugin
export default {"root":"cFGCnqcA","content":"sRTywfr2","actions":"u6bKEBnR","title":"UervEVFY","description":"rO8yQetD","img":"T1ztMNGQ","button":"eymlW7_B"};